import { useEffect, useState } from "react";
import Bowser from "bowser";

import { isMobileDevice } from "../../utils/isMobileDevice";

export interface PlatformType {
  isMobile: boolean;
  isIos: boolean;
  browser?: string;
  browserVersion?: string;
  os?: string;
  osVersion?: string;
}

export const usePlatformType: () => PlatformType = () => {
  const isDeviceTypeMobile = isMobileDevice();
  const [mobile, setMobile] = useState(isDeviceTypeMobile);
  const platformInfo = Bowser.parse(window.navigator.userAgent);
  const [platform, setPlatform] = useState(platformInfo);

  useEffect(() => {
    const isMobileDevice =
      isDeviceTypeMobile ||
      platformInfo.platform.type?.toLowerCase() === "mobile";
    setMobile(isMobileDevice);
    setPlatform(platformInfo);
  }, [isDeviceTypeMobile, platformInfo]);

  return {
    isMobile: mobile,
    isIos: platform.os.name?.toLowerCase() === "ios",
    browser: platform.browser.name,
    browserVersion: platform.browser.version,
    os: platform.os.name,
    osVersion: platform.os.versionName,
  };
};
